export const DashedLineVariants = ['6 6', '2 2', '12 2', '8 2 2 2', undefined]
